import React from 'react';
import Image from 'components/image';
import DescriptionList from 'components/description-list';
import PropTypes from 'prop-types';

const ProductSpecifications = ({ metadataItems, measurementItems }) => (
  <div className="product-specifications">
    <div className="product-specifications__list-columns">
      {metadataItems && (
        <div className="product-specifications__list-col">
          <DescriptionList items={metadataItems} />
        </div>
      )}
      {measurementItems && (
        <div className="product-specifications__list-col">
          <DescriptionList items={measurementItems} />
        </div>
      )}
    </div>
  </div>
);

ProductSpecifications.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string,
  metadataItems: PropTypes.arrayOf(
    PropTypes.shape({
      tag: PropTypes.string,
      description: PropTypes.string
    })
  ),
  measurementItems: PropTypes.arrayOf(
    PropTypes.shape({
      tag: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.exact(Image.propTypes)
    })
  )
};

export default ProductSpecifications;
